// DEF-97 — Clerk ↔ react-router. Without `routerPush` / `routerReplace`, Clerk leaves the sign-in page with a
// full browser navigation (window.location): a blank frame (~2 s on staging) and a whole-app reload after every
// sign-in. Handing Clerk the router's `navigate` keeps those redirects inside the SPA. Clerk still does a full
// navigation itself for a cross-origin destination (e.g. its hosted pages), so only in-app paths reach `navigate`.
// Must render INSIDE <BrowserRouter> (it calls useNavigate).
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { ClerkProvider } from '@clerk/clerk-react'

export function ClerkWithRouter({ publishableKey, children }: { publishableKey: string; children: React.ReactNode }) {
  const navigate = useNavigate()
  return (
    <ClerkProvider
      publishableKey={publishableKey}
      // Issue 33b (2026-09-01): disable Clerk's usage telemetry so the SDK never beacons
      // clerk-telemetry.com — the one origin the CSP report-only soak flagged (connect-src).
      // Resolved at the source instead of widening the allowlist, so the enforcing CSP stays tight.
      telemetry={false}
      signInUrl="/sign-in"
      signUpUrl="/sign-up"
      signInFallbackRedirectUrl="/"
      signUpFallbackRedirectUrl="/"
      routerPush={(to: string) => navigate(to)}
      routerReplace={(to: string) => navigate(to, { replace: true })}
    >
      {children}
    </ClerkProvider>
  )
}
